import SFAuthService, { NO_USER } from 'app/services/sfAuth/SFAuthService'
import { CommonFlowResult } from '../salesforce-maps/CommonTypes'
import { ContentVersionSF } from '../salesforce-maps/ContentVersion'

export const uploadFileByFlow = async (
  toCreate: Partial<ContentVersionSF>
): Promise<CommonFlowResult[]> => {
  const conn = SFAuthService.getConnection()
  if (conn == null) {
    return await Promise.reject(NO_USER)
  }
  return conn.requestPost('/actions/custom/flow/App_Create_Document', {
    inputs: [
      {
        toCreate
      }
    ]
  })
}
